import { Optional } from 'utils/optional/optional';
import { MsftPrivateOffer } from '../types/MsftPrivateOffer';

export const offerHasPreviewFeatures = (offer: Partial<MsftPrivateOffer>) => {
  return Optional.ofNullable(offer.pricing)
    .filter((p) => !!p.paymentSchedule)
    .isPresent();
};
